import styled from "styled-components";

export default styled.div`
  overflow: hidden; 
  background: #F9FAFB;

  .react-flow__handle {
    opacity: 0;
  }

  .react-flow__node {
    border-radius: 8px;
    border: 1px solid var(--base-gray-30) !important;
    box-shadow: 0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08) !important;
  }

  .node-cont {
    display: flex;

    .img-cont {
      margin-right: 8px;

      img {
        width: 50px;
        height: 50px;
      }
    }

    .name-cont {
      display: flex;
      flex-direction: column;
      justify-content: center;

      label {
        margin-bottom: 0px;
        width: 100px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: left;
        font-size: 10px;
        color: var(--base-gray-70);

        &.name {
          font-size: 14px;
          color: var(--base-gray-90);
        }
      }
    }
  }
`;
